<template>
  <!-- 在售素材 -->
  <div style="background-color: #f5f5f5; margin-top: 0.7rem">
    <div class="newTrialMaterial comBox">
      <div class="left">
        <leftTemplate1 :left_tabShow="'on_sale_material'"></leftTemplate1>
      </div>
      <div class="right">
        <div style="
            display: flex;
            justify-content: space-between;
            padding: 0.12rem 0.16rem;
            box-sizing: border-box;
          ">
          <!-- <el-input style="width:500px" v-model="keyWord" placeholder="搜索素材名称" clearable>
						<template #prepend>
							<el-button :icon="Search" @click="keywordsearch" />
						</template>
					</el-input> -->
          <div></div>
          <div :icon="Search" style="cursor: pointer" class="topBtn" @click="handleDel('', '', 'delAll')">
            批量删除
          </div>
        </div>
        <!-- <div v-if="data.length != 0"> -->
        <el-table ref="multipleTableRef" :data="list" style="width: 100%" @selection-change="handleSelectionChange"
          height="650" width="100%">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column property="name" min-width="140" label="商品信息" align="center">
            <template #header>
              <div style="display: flex; width: 100%">
                <!-- <div>
                  <span
                    @click="selectAll"
                    v-if="!allCheckbox"
                    class="el-checkbox__inner_zd"
                  ></span>
                  <span
                    @click="selectAll"
                    v-if="allCheckbox"
                    class="el-checkbox__inner_select"
                  ></span>
                  <span style="margin-top: -10px; margin-left: 5px; color: #666"
                    >全选</span
                  >
                </div> -->

                <el-dropdown @command="dropdownClick">
                  <span class="el-dropdown-link">
                    {{
                      top_type == "MUSIC"
                      ? "音乐"
                      : top_type == "VIDEO"
                        ? "视频"
                        : top_type == "IMAGE"
                          ? "图片"
                          : "全部素材模板"
                    }}
                    <img style="width: 14px; height: 14px" src="../../assets/img/dropselect2.png" />
                  </span>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item command="">全部素材模板</el-dropdown-item>
                      <el-dropdown-item command="VIDEO">视频</el-dropdown-item>
                      <el-dropdown-item command="MUSIC">音乐</el-dropdown-item>
                      <el-dropdown-item command="IMAGE">图片</el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </div>
            </template>

            <template #default="scope">
              <div style="display: flex">
                <div style="" class="table_img">
                  <el-image style="width: 100%; height: 100%" :src="scope.row.showImage" :zoom-rate="1.2"
                    :preview-src-list="[scope.row.showImage]" :initial-index="4" fit="cover">
                    <template #error>
                      <div class="image-slot" style="width: 100%; height: 100%">
                        <img style="width: 100%; height: 100%" src="../../assets/img/noImg.png" />
                      </div>
                    </template>
                  </el-image>
                </div>
                <div class="table_information">
                  <div style="
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      color: #333333;
                      width: 100%;
                    ">
                    {{ scope.row.title ? scope.row.title : scope.row.name }}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>

          <!-- <el-table-column
            property="seeCount"
            width="50"
            label="观看"
            align="center"
          /> -->
          <el-table-column property="payCount" width="50" label="购买" align="center" />
          <el-table-column property="selfPrice" width="107" label="个人授权售价" align="center" />
          <el-table-column property="createTime" width="170" label="创建时间" align="center" />
          <el-table-column property="updateTime" width="170" label="更新时间" align="center" />
          <el-table-column property="time1" width="100" label="上架/下架" align="center">
            <template #header>
              <el-dropdown @command="dropdownIsOnlinClick">
                <span class="el-dropdown-link">
                  上架/下架
                  <img style="width: 14px; height: 14px" src="../../assets/img/dropselect2.png" />
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item command="0">上架</el-dropdown-item>
                    <el-dropdown-item command="1">下架</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </template>
            <template #default="scope">
              <span v-if="scope.row.isOnline == 0" class="satatusLab"
                style="background: #4bc18520; color: #4bc185">上架</span>
              <span v-else class="satatusLab" style="background: #f53f3f20; color: #f53f3f">下架</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template #default="scope">
              <div style="display: flex">
                <div class="topBtn" style="cursor: pointer" @click="handlePerfect(scope.row)">
                  修改信息
                </div>
                <div @click="handleDel(scope.$index, scope.row, 'del')" style="
                    color: #ff2929;
                    margin-left: 0.1rem;
                    line-height: 0.43rem;
                    cursor: pointer;
                  ">
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
          <template #empty>
            <div style="height: 550px" v-if="list.length == 0">
              <div style="width: 90%; margin: 0 auto">
                <img style="width: 100%; margin: 0 auto" src="../../assets/zt_404.png" />
              </div>
            </div>
          </template>
        </el-table>
        <!-- size-change page-size 改变时触发
					current-change current-page 改变时触发
					prev-click 用户点击上一页按钮改变当前页时触发
					next-click 用户点击下一页按钮改变当前页时触发
					pageNum 和 pageSize 分别是页数和每页显示大小 -->

        <el-pagination v-if="list.length != 0" v-model:current-page="page.pageNum" v-model:page-size="page.pageSize"
          @size-change="sizeChange" @current-change="currentChange" style="margin: 0.4rem 0" background
          layout="prev, pager, next" :total="page.total" />
      </div>
    </div>
    <!-- 删除 -->
    <el-dialog title="" v-model="dialogDelVisible" align-center width="480px" :close-on-click-modal="false">
      <div style="width: 0.4rem; height: 0.4rem; margin: 0 auto">
        <img style="100%;height: 100%;" src="@/assets/img/tips／exclamation-circle-fill@2x.png" />
      </div>

      <div style="text-align: center; font-size: 0.16rem; margin: 0.16rem 0">
        {{ title }}
      </div>
      <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click="dialogDelVisible = false">取消</div>
        <div class="dataBtnSubmit" @click="delSubmit">确认</div>
      </div>
    </el-dialog>
  </div>
</template>

<script lang="ts" setup>
import leftTemplate1 from "@/components/leftTemplate1.vue";
import { ref } from "vue";
import type { TabsPaneContext } from "element-plus";
import { ElMessage, ElTable } from "element-plus";
import { Search } from "@element-plus/icons-vue";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { serverUrls } from "../../assets/js/ls_tgServerUrls.js";

let pageDef = ref({
  pageNum: 1,
  pageSize: 5,
  total: 0,
});
const page = pageDef;
const keyWord = ref("");
const activeName = ref("first");
const top_type = ref("");
const isOnlin = ref("");
var list = ref([]); // 创建一个空数组
// 表格
const allCheckbox = ref(false);
interface User {
  date: string;
  name: string;
  address: string;
  katype: string;
  pirce: string;
  number: number;
  number1: number;
  time: string;
  time1: string;
}

const multipleTableRef = ref<InstanceType<typeof ElTable>>();
const multipleSelection = ref<User[]>([]);
const toggleSelection = (rows?: User[]) => {
  if (rows) {
    rows.forEach((row) => {
      multipleTableRef.value!.toggleRowSelection(row, undefined);
    });
  } else {
    multipleTableRef.value!.clearSelection();
  }
};
const handleSelectionChange = (val: User[]) => {
  multipleSelection.value = val;
  if (multipleSelection.value.length == list.value.length) {
    allCheckbox.value = true;
  } else if (multipleSelection.value.length == 0) {
    allCheckbox.value = false;
    // multipleTableRef.value!.clearSelection()
  } else {
    allCheckbox.value = false;
  }
  console.log(allCheckbox.value, "单选点击后全选状态");
  // 使用map方法提取id并组成新的数组
  idArray.value = multipleSelection.value.map((obj) => obj.id);
};
const selectAll = () => {
  allCheckbox.value = !allCheckbox.value;
  console.log(allCheckbox.value);
  if (allCheckbox.value) {
    list.value.forEach((item, index) => {
      console.log(multipleTableRef.value);
      multipleTableRef.value!.toggleRowSelection(item, true);
    });
  } else {
    list.value.forEach((item, index) => {
      console.log(multipleTableRef.value);
      multipleTableRef.value!.toggleRowSelection(item, false);
    });
  }
};
//列表请求
let memberId = JSON.parse(localStorage.getItem("userList")).memberId;
const init = () => {
  let paramsA = {};
  paramsA = {
    memberId: memberId,
    materialType: top_type.value,
    isOnline: isOnlin.value,
    pageNum: page.value.pageNum,
    pageSize: page.value.pageSize,
  };
  console.log(paramsA);
  Axios("get", "/fodder/manage/on-list", paramsA, false, function (res) {
    console.info(res);
    list.value = res.data.rows;
    console.info(list.value);
    page.value.total = res.data.total;
  });
};

init();

// 删除、批量删除

let title = ref("");
let dialogDelVisible = ref(false);
let idArray = ref([]);
const handleDel = (index, row, type) => {
  console.log(idArray.value);
  if (idArray.value.length == 0) {
    ElMessage({
      message: "请选择选择需要删除的素材",
      type: "warning",
    });
    return;
  }
  title.value =
    type == "del"
      ? "删除后则无法恢复，是否继续？"
      : "是否确认将所选全部在售素材？";
  if (type == "del") {
    if (row.id) {
      idArray.value = [row.id];
      dialogDelVisible.value = true;
    } else {
      list.value.splice(index, 1);
    }
  } else {
    dialogDelVisible.value = true;
  }
};
const delSubmit = () => {
  console.log("删除", idArray);
  Axios(
    "delete",
    `/fodder/manage/remove/` + idArray.value,
    {},
    false,
    (res) => {
      if (res.data.code == 200) {
        dialogDelVisible.value = false;
        init();
        ElMessage({
          message: "删除成功",
          type: "success",
        });
      } else {
        ElMessage({
          message: "删除错误",
          type: "error",
        });
      }
    }
  );
};
//直接跳转
import { useRouter } from "vue-router";
const router = useRouter();
const handlePerfect = (row) => {
  // IMAGE, MUSIC, VIDEO
  if (row.materialType == "VIDEO") {
    router.push({
      path: "/materiaPerfect",
      query: {
        id: row.id,
      },
    });
  } else if (row.materialType == "MUSIC") {
    router.push({
      path: "/musicPerfect",
      query: {
        id: row.id,
      },
    });
  } else if (row.materialType == "IMAGE") {
    router.push({
      path: "/picturePerfect",
      query: {
        id: row.id,
      },
    });
  }
};
//全部素材选择

const dropdownClick = (command: string | number | object) => {
  console.log(command, "-----------------");
  top_type.value = command;
  init();
  // IMAGE, MUSIC, VIDEO
};

const dropdownIsOnlinClick = (command: string | number | object) => {
  console.log(command, "-----------------");
  isOnlin.value = command;
  init();
};
/**
 * 分页
 * sizeChange
 * currentChange
 * prevClick
 * nextClick
 *
 */
const sizeChange = (val: number) => {
  console.log(val);
  init();
};
const currentChange = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};
const prevClick = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};
const nextClick = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};

//搜索事件
const keywordsearch = () => { };
</script>

<style scoped>
@import url(/src/assets/css/left_right.css);
@import url(/src/assets/css/com.css);

.newTrialMaterial {
  display: flex;
  margin: 0 auto;
}

.newTrialMaterial_box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0.2rem 0.17rem;
  box-sizing: border-box;
  vertical-align: middle;
  background-color: #f2f3f5;
}

.topBtn {
  /* width: 100px; */
  font-size: 14px;
  /* padding: 0.06rem 0.16rem; */
  text-align: center;
  color: #333333;
  background: #ffffff;
  border-radius: 0.2rem;
  opacity: 1;
  line-height: 43px;
  padding: 0 10px;
  border: 0.01rem solid #e5e6eb;
  margin-left: 0.2rem;
}

.table_img {
  background-color: #3fa4ed;
  width: 100px;
  height: 80px;
  background: #d9d9d9;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  opacity: 1;
  margin-right: 0.1rem;
}

.table_information {
  width: calc(100% - 1.2rem - 0.1rem);
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/deep/ .el-table .el-table__cell {
  /* z-index: none; */
  position: static;
}

/deep/ .el-image-viewer__canvas img {
  height: 70%;
}

/deep/ .el-table th.el-table__cell.is-leaf {
  background: #e3e6ec !important;
}

/* /deep/th .cell .el-checkbox__input {
  display: none;
} */

/deep/.el-checkbox.el-checkbox--large {
  height: 0.2rem !important;
}

/deep/.is-active {
  color: #c01a26;
}

/deep/.el-tabs__active-bar {
  display: none;
}

/deep/.el-tabs__nav {
  padding: 0 0.16rem;
}

/deep/.el-tabs__item:hover {
  color: #c01a26 !important;
}

/deep/.el-table .cell {
  padding: 0 4px !important;
}

/deep/.el-dialog.is-align-center {
  border-radius: 20px !important;
}

/deep/.rate .el-icon,
/deep/.rate .el-icon svg {
  height: 2em !important;
  width: 2em !important;
}

/deep/.el-tabs__active-bar {
  display: none !important;
}

/deep/.el-tabs__item:hover {
  color: #c01a26;
}

/deep/.el-tabs__item.is-active {
  color: #c01a26;
}

/deep/.el-tabs__nav-scroll {
  padding-left: 0.12rem;
}

/deep/ .el-dropdown-link:focus {
  outline: none;
}

.satatusLab {
  padding: 0.02rem 0.06rem;
  box-sizing: border-box;
  border-radius: 0.05rem;
  margin-left: 0.12rem;
  display: inline-block;
}

/* 全选自定义 */
.el-checkbox__inner_zd {
  width: 14px;
  height: 14px;
  display: inline-block;
  position: relative;
  border: 1px solid #ccc;
  border-radius: 2px;
  box-sizing: border-box;
  /* width: var(--el-checkbox-input-width);
		height: var(--el-checkbox-input-height); */
  background-color: #fff;
  z-index: var(--el-index-normal);
  transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    outline 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}

.el-checkbox__inner_select::after {
  box-sizing: content-box;
  content: "";
  border: 1px solid transparent;
  border-left: 0;
  border-top: 0;
  height: 7px;
  left: 4px;
  position: absolute;
  top: 1px;
  transform: rotate(45deg) scaleY(0);
  width: 3px;
  transition: transform 0.15s ease-in 50ms;
  transform-origin: center;
  transform: rotate(45deg) scaleY(1);
  border-color: var(--el-checkbox-checked-icon-color);
}

.el-checkbox__inner_select {
  width: 14px;
  height: 14px;
  display: inline-block;
  position: relative;
  border: 1px solid #409eff;
  border-radius: 2px;
  box-sizing: border-box;
  color: #fff;
  background-color: #409eff;
  z-index: var(--el-index-normal);
  transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    outline 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}

/deep/.el-dropdown-link {
  line-height: 23px !important;
  color: var(--el-table-header-text-color) !important;
}

/* 分页 */

.el-pagination {
  justify-content: center;
}

/deep/.el-pager li {
  padding: 0.06rem;
  margin: 0 0.03rem;
}

/deep/.el-pager li.is-active {
  color: #fff;
  background: #c01a26;
}

/deep/.el-pager li:hover {
  color: #fff;
  background: #c01a26;
}

/deep/ .el-pagination.is-background .el-pager li.is-active {
  background: #c01a26;
}

/deep/.el-popper:focus {
  outline: none !important;
}
</style>
